// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { t } from "@lingui/macro"
import { create } from "@bufbuild/protobuf"
import * as TimelineActions from "../actions"
import * as TimelineSlice from "../slices/timeline"
import { showSnackBar } from "../../snackbar/actions"
import { executor, Init, timelineService } from "../../../app/rpc"
import {
  ListTimeRowsByDateRequestSchema,
  ListTimeRowsByDateResponse,
} from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

type ListTimeRowsByDateRpc = (request: Init<typeof ListTimeRowsByDateRequestSchema>) => Observable<ListTimeRowsByDateResponse>

export const listTimeRowsByDate = (listTimeRowsByDateRpc: ListTimeRowsByDateRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(TimelineActions.listTimeRowsByDate.match),
      mergeMap(action => listTimeRowsByDateRpc(action.payload).pipe(
        map(t => t.timeRows),
        map(timeRowsList => TimelineSlice.setTimeRowsForDates({
          timeRows: timeRowsList,
          window: {
            startDateLocal: action.payload.startActivityDate ?? 0,
            endDateLocal: action.payload.endActivityDate ?? 0,
          },
          ofTrashStatus: action.payload.trashStatus,
        })),
        catchError(_ => of(showSnackBar({
          message: t({ id: "msg_list_time_rows_failed", message: "Failed to get fetch time rows. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
          messageType: "ERROR",
        })))),
      )
    )

const listTimeRowsByDateRpc = (request: Init<typeof ListTimeRowsByDateRequestSchema>): Observable<ListTimeRowsByDateResponse> =>
  executor(() => timelineService.listTimeRowsByDate(create(ListTimeRowsByDateRequestSchema, request)))

export default listTimeRowsByDate(listTimeRowsByDateRpc)
